import SiteHeaderDesktop from './SiteHeaderDesktop';
import SiteHeaderDesktopContainer from './SiteHeaderDesktop.container';

export default SiteHeaderDesktopContainer(SiteHeaderDesktop);
